<template>
  <div class="form-check">
    <label :for="id" class="custom-control-label" :class="$attrs.class">
      <slot />
    </label>
    <input
      :id="id"
      type="checkbox"
      :name="name"
      :disabled="disabled"
      :checked="checked"
      @input="handleCheckboxValue"
    />
  </div>
</template>

<script>
export default {
  name: "SoftCheckbox",
  props: {
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input"],
  methods: {
    handleCheckboxValue(e) {
      this.$emit("input", e.target.checked);
    },
  },
};
</script>
